import React from 'react';
import Description from 'components/typography/Description';

const DirectionsInputDescription = () => {
  return (
    <Description>
      Describe <b>step by step</b> how to prepare this recipe.
    </Description>
  );
};

export default DirectionsInputDescription;
